import volumeOffImg from '@/assets/images/volumeMute.svg';
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

// グローバルタイマー変数
let imageTimeoutId = null;
// タイマー開始時刻とdurationを記録する変数
let imageTimerStartTime = null;
let imageTimerDuration = null;

// タイマーをクリアする関数
export const clearImageTimer = () => {
  if (imageTimeoutId !== null) {
    clearTimeout(imageTimeoutId);
    imageTimeoutId = null;
    // タイマー情報もリセット
    imageTimerStartTime = null;
    imageTimerDuration = null;
  }
};

// タイマーをセットする関数
export const setImageTimer = (callback, duration) => {
  clearImageTimer();
  // タイマー開始時刻とdurationを記録
  imageTimerStartTime = Date.now();
  imageTimerDuration = duration;
  imageTimeoutId = setTimeout(callback, duration);
};

// 共通のメディア切り替え処理
export const commonChangeMediaProcess = (contents) => {
  // メディアが切り替わるときにタイマーをクリア
  clearImageTimer();

  const activeSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
  const movie = activeSlide.querySelector('.storeeel-movie');
  const image = activeSlide.querySelector('.storeeel-media-image');
  const mediaAsset = contents[window.moviePosition].mediaAsset;
  const mimeType = mediaAsset.attachmentData.metadata.mime_type;
  const volumeIcon = document.querySelector('#volume-desktop');
  const slideMediaWrapper = activeSlide.querySelector('.storeeel-swiper-group-wrapper .slide-media-wrapper');
  slideMediaWrapper.style.visibility = 'hidden';

  trackStoreeelEvent('storeeel_media_asset_view', {
    'storeeel_name':  mediaAsset.name,
    'group_id': window.iconId,
    'media_id': mediaAsset.id,
    'campaign_id': window.storeeelItems.id,
  })
  localStorageRepositories.get("mediaView").set(
    mediaAsset.id,
    window.storeeelItems.id
  )

  if (mimeType.includes('image')) {
    if (image) {
      image.src = mediaAsset.mediaUrl;
      image.style.display = 'block';
      image.setAttribute('media-name', mediaAsset.name);
      image.setAttribute('media-id', mediaAsset.id);
      image.classList.add('active');
    } else {
      const imageElement = document.createElement('img');
      imageElement.src = mediaAsset.mediaUrl;
      imageElement.className = 'storeeel-media-image';
      imageElement.style.objectFit = 'contain';
      imageElement.setAttribute('media-name', mediaAsset.name);
      imageElement.setAttribute('media-id', mediaAsset.id);
      imageElement.classList.add('active');
      slideMediaWrapper.appendChild(imageElement);
    }
    if (movie) {
      movie.style.display = 'none';
      movie.muted = true;
      movie.classList.remove('active');
    }
    if (volumeIcon) {
      volumeIcon.style.visibility = 'hidden';
    }
  } else {
    clearImageTimer();
    if (movie) {
      movie.src = mediaAsset.mediaUrl;
      movie.dataset.type = mediaAsset.name;
      movie.style.display = 'block';
      movie.setAttribute('media-name', mediaAsset.name);
      movie.setAttribute('media-id', mediaAsset.id);
      movie.classList.add('active');
    } else {
      const videoElement = document.createElement('video');
      videoElement.src = mediaAsset.mediaUrl;
      videoElement.className = 'storeeel-movie';
      videoElement.setAttribute('media-name', mediaAsset.name);
      videoElement.setAttribute('media-id', mediaAsset.id);
      videoElement.setAttribute('playsinline', 'true');
      videoElement.setAttribute('autoplay', 'true');
      videoElement.muted = true; // デフォルトでミュート
      videoElement.classList.add('active');
      slideMediaWrapper.appendChild(videoElement);
    }
    if (image) {
      image.style.display = 'none';
      image.classList.remove('active');
    }
    if (volumeIcon) {
      volumeIcon.style.visibility = 'visible';
      if (movie && movie.muted) {
        volumeIcon.src = volumeOffImg;
      }
    }
  }
  requestAnimationFrame(() => {
    // mediaの差し替え後に再表示
    slideMediaWrapper.style.visibility = 'visible';
  });
};

// バナーの更新処理
export const updateBanners = () => {
  const banners = document.querySelectorAll('.storeeel-movie-select_banner');
  banners.forEach((banner) => {
    banner.style.padding = '1px';
  });
  if (banners[window.moviePosition]) {
    banners[window.moviePosition].style.padding = '2px';
  }
};

// 画像のタイマーの残り時間を取得する関数
export const getImageTimerRemainingTime = () => {
  // タイマーが設定されていない場合は0を返す
  if (imageTimeoutId === null || imageTimerStartTime === null || imageTimerDuration === null) {
    return 0;
  }

  // 経過時間を計算
  const elapsedTime = Date.now() - imageTimerStartTime;

  // 残り時間を計算（ミリ秒単位）
  const remainingTime = Math.max(0, imageTimerDuration - elapsedTime);

  return remainingTime;
};

// 画像のタイマーを一時停止する関数
export const pauseImageTimer = () => {
  if (imageTimeoutId !== null) {
    // 残り時間を取得
    const remainingTime = getImageTimerRemainingTime();

    // タイマーをクリア
    clearTimeout(imageTimeoutId);
    imageTimeoutId = null;

    // 残り時間を保持しておく（再開時に使用するため）
    return remainingTime;
  }
  return 0;
};

// 画像のタイマーを再開する関数
export const resumeImageTimer = (callback, remainingTime) => {
  if (remainingTime > 0) {
    imageTimerStartTime = Date.now();
    imageTimerDuration = remainingTime;
    imageTimeoutId = setTimeout(callback, remainingTime);
    return imageTimeoutId;
  }
  return null;
};
